import {
  DefaultButton,
  FontSizes,
  Label,
  NeutralColors,
  Panel,
  PanelType,
  TextField,
  setVirtualParent,
} from "@fluentui/react";
import { useCallback, useEffect, useState } from "react";
import { MensajeBar } from "../../../components/generic/ManejoResponseMessage/MessageBar";
import IdicadorProgress from "../../../components/generic/IndicadorProgress";
import { PanelFooterGestionDocumentos } from "../general/PanelFooterGestionDocumentos";
import { _helperIBaseResponse } from "../../../Interfaces/gestionDocumentos/ITipoDocumento";
import grupoDocumentoService from "../../../services/gestionDocumentos/grupoDocumentoService";
import { IEditarDocumento } from "../../../Interfaces/gestionDocumentos/IDocumento";

interface IPanelEditarDocumento {
  isOpen: boolean;
  onDismiss: () => void;
  onRenderTable: () => void;
  archivoId: string;
  nombre: string;
}

export const PanelEditarDocumento = (props: IPanelEditarDocumento) => {
  const [isSend, setIsSend] = useState(false);
  const [isSaccesfull, setIsSaccesfull] = useState(false);
  const [isError, setIsError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");
  const [mensaje, setMensaje] = useState("");

  const [isContenedor, setIsContenedor] = useState(false);
  const [disableForm, setDisableForm] = useState(true);

  const [nombreTipo, setNombreTipo] = useState("");
  const [isExceeded, setIsExceeded] = useState(false);

  const [detalleArchivo, setDetalleArchivo] = useState<IEditarDocumento>({
    archivoId: "",
    nombre: "",
    archivo: "",
    nombreArchivo: "",
    extension: "",
    tipo: "",
  });

  const onClickUpload = (ev?: any) => {
    Promise.resolve().then(() => {
      const inputElement = document.createElement("input");
      inputElement.style.visibility = "hidden";
      inputElement.setAttribute("type", "file");
      inputElement.setAttribute("accept", ".pdf");
      inputElement.onchange = function (ev) {
        let { files } = ev.target as HTMLInputElement;

        if (files != undefined) {
          const file: File = files[0];
          setIsExceeded(false);

          // Convertir el tamaño a kilobytes
          const fileSizeKB = file.size / 1024;

          // Convertir el tamaño a megabytes
          const fileSizeMB = fileSizeKB / 1024;
          if (fileSizeMB > 20) {
            setIsExceeded(true);
            return;
          }

          let nomExtension = file.name.split(".").pop();
          var formData = new FormData();
          formData.append("file", file, file.name);

          fileToBase64(file, (err, result) => {
            if (result) {
              setDetalleArchivo({
                ...detalleArchivo,
                archivo: result,
                extension: `.${nomExtension}`,
                nombreArchivo: file.name,
              });
            }
          });
        }
      };
      document.body.appendChild(inputElement);
      const target = ev?.target as HTMLElement | undefined;
      if (target) {
        setVirtualParent(inputElement, target);
      }
      inputElement.click();
      if (target) {
        setVirtualParent(inputElement, null);
      }
      setTimeout(() => {
        inputElement.remove();
      }, 10000);
    });
  };

  const fileToBase64 = (file, cb) => {
    const myReader: FileReader = new FileReader();

    myReader.readAsDataURL(file);
    myReader.onloadend = function () {
      cb(null, myReader.result);
    };

    myReader.onerror = function (error) {
      cb(error, null);
    };
  };

  useEffect(() => {
    if (props.isOpen) {
      setIsSend(false);
      setIsSaccesfull(false);
      validarForm();
      if (props.archivoId && props.nombre) {
        setDetalleArchivo({
          ...detalleArchivo,
          archivoId: props.archivoId,
          nombre: props.nombre,
          tipo: "03",
        });
      }
    }
  }, [props.isOpen]);

  useEffect(() => {
    validarForm();
  }, [detalleArchivo]);

  const validarForm = () => {
    if (detalleArchivo == null) setDisableForm(true);
    if (detalleArchivo !== null) {
      if (detalleArchivo.nombre && detalleArchivo.archivoId) {
        setDisableForm(false);
      } else {
        setDisableForm(true);
      }
    }
  };

  const onRenderHeader = useCallback(
    () => (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "0px 24px",
            width: "100%",
          }}
        >
          <div
            style={{
              color: NeutralColors.gray130,
              fontSize: FontSizes.size20,
            }}
          >
            Actualizar Documento
          </div>
          <div
            style={{
              color: NeutralColors.gray130,
              fontSize: FontSizes.size12,
            }}
          ></div>
        </div>
      </>
    ),
    []
  );

  const _confirmar = () => {
    if (props.archivoId) {
      setIsSend(true);
      setDisableForm(true);
      setIsContenedor(true);
      grupoDocumentoService
        .editarGrupoDocumento(detalleArchivo)
        .then((res) => {
          if (res.status === 200) {
            setIsSend(false);

            if (res.data.confirmacion) {
              setIsSaccesfull(true);
              setMensaje(res.data.mensaje);
              props.onRenderTable();
              setNombreTipo("");
              //Clone Panel after one second
              setTimeout(() => {
                _goback();
              }, 1000);
            } else {
              setIsError(true);
              setMensajeError(res.data.mensaje);
            }
          }
        })
        .catch((err: Error) => {
          setIsSend(false);
          setIsError(true);
          setMensajeError("No se pudo Actualizar el Documento");
        });
    }
  };

  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooterGestionDocumentos
          texto="Actualizar"
          texto2={"Cancelar"}
          onClick={() => {
            _confirmar();
          }}
          onDismiss={() => {
            _goback();
          }}
          disableButton={disableForm}
        />
      </>
    ),
    [props.onDismiss, validarForm, _confirmar]
  );

  const onChange = (e: any, data: string | undefined) => {
    if (data != undefined) {
      setDetalleArchivo({ ...detalleArchivo, nombre: data });
    }
  };

  const limpiarResponse = () => {
    setIsSend(false);
    // setIsContenedor(true);
    setIsSaccesfull(false);
    setNombreTipo("");
    setIsError(false);
    setMensajeError("");
    setMensaje("");
    setDetalleArchivo({
      ...detalleArchivo,
      nombre: "",
      archivo: "",
      nombreArchivo: "",
      extension: "",
    });
    props.onDismiss();
  };

  const _goback = () => {
    limpiarResponse();
    setIsContenedor(false);
  };

  return (
    <Panel
      isOpen={props.isOpen}
      onDismiss={_goback}
      onRenderHeader={onRenderHeader}
      onRenderFooter={onRenderFooter}
      type={PanelType.custom}
      customWidth="400px"
      isFooterAtBottom={true}
      isLightDismiss={true}
    >
      <>
        <br />
        {isSend && (
          <IdicadorProgress subText="Registrando Datos" isSend={isSend} />
        )}

        {isSaccesfull == true && (
          <MensajeBar
            ocultar={() => limpiarResponse()}
            response={{
              mensaje: mensaje,
              codigoMensaje: 1,
            }}
          />
        )}

        {isError == true && (
          <MensajeBar
            ocultar={() => limpiarResponse()}
            response={{ mensaje: mensajeError, codigoMensaje: 3 }}
          />
        )}
        {/* <pre>{JSON.stringify(detalleArchivo, null, 2)}</pre> */}

        <div hidden={isContenedor}>
          <TextField
            onChange={onChange}
            value={detalleArchivo.nombre}
            label="Nombre de Documento"
            required
            placeholder="Ingrese el nombre"
          />
          <br />
          <div>
            <div>
              <Label>Elegir Archivo (.pdf)</Label>
              <DefaultButton
                text="Elegir Archivo"
                iconProps={{ iconName: "Upload" }}
                onClick={onClickUpload}
                allowDisabledFocus
                disabled={false}
                checked={false}
              />
            </div>
            <Label styles={{ root: { color: "rgb(0, 120, 212)" } }}>
              {detalleArchivo.nombreArchivo}
            </Label>
          </div>
          {isExceeded && (
            <div style={{ marginTop: "20px" }}>
              <Label>
                ¡El Documento no puede superar los 20 MB, Suba Otro Documento!
              </Label>
            </div>
          )}
        </div>
      </>
    </Panel>
  );
};
